export default {"src":"/_next/static/media/applepay.358e0448.svg","height":26,"width":60,"blurWidth":0,"blurHeight":0};